import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/my',
			name: 'my',
			component: () => import('./views/My.vue')
		},
		{
			path: '/login',
			name: 'login',
			component: () => import('./views/Login.vue')
		},
		{
			path: '/cart',
			name: 'cart',
			component: () => import('./views/Cart.vue')
		},
		{
			path: '/order_confirm',
			name: 'orderConfirm',
			component: () => import('./views/OrderConfirm.vue')
		}
	]
})
